import React from 'react';
import { useNavigate } from 'react-router-dom';
import { List, Users, LogOut, MessageSquare, ExternalLink } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';

export default function QuoteSelectionPage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const options = [
    {
      title: 'Quote List',
      description: 'View and manage your personal collection of quotes',
      icon: List,
      action: () => navigate('/quotes'),
      color: 'bg-blue-500'
    },
    {
      title: 'Community Quote Wall',
      description: 'Explore and share quotes with the community',
      icon: Users,
      action: () => window.open('https://quotewall.mygoodquotes.com', '_blank'),
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-end gap-4 mb-4">
          <a
            href="https://guides.mygoodquotes.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500"
          >
            <ExternalLink className="h-4 w-4" />
            Quote Guides
          </a>
          <button
            onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSeulAweEFxbcQFDNXFmRA7jyzjU2Ceqt70PQK1xwtu005xy-g/viewform', '_blank')}
            className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            <MessageSquare className="h-4 w-4" />
            Feedback
          </button>
          <button
            onClick={signOut}
            className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>

        <div className="text-center mb-12">
          <img 
            src="https://llmdocs.s3.us-east-1.amazonaws.com/mygoodquotes/blogimages/mgqlogo2.png"
            alt="MyGoodQuotes Logo"
            className="h-24 w-auto mx-auto mb-8"
          />
          <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Welcome to MyGoodQuotes
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Choose how you'd like to explore quotes today
          </p>
        </div>

        <div className="flex flex-col items-center justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl w-full">
            {options.map((option) => {
              const Icon = option.icon;
              return (
                <button
                  key={option.title}
                  onClick={option.action}
                  className="relative group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 text-left w-full"
                >
                  <div className={`inline-flex p-3 rounded-lg ${option.color} text-white mb-4`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-2">
                    {option.title}
                  </h2>
                  <p className="text-gray-600">
                    {option.description}
                  </p>
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-blue-500 rounded-lg transition-all duration-200" />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
